module.exports = __webpack_public_path__ + "static/kalda-logo-e6e5cf39d13166176d622f79a06b3aea.svg";